import React from 'react'
import Input from './Input'
import styles from './styles'

export default class CompanyInput extends Input {
  render() {
    return (
      <div className={styles.wrapper} style={this.style}>
        <input
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          className={this.className()}
          name='Company'
          type='text'
          aria-label='Company'
          required='true'
          value={this.state.value}
          autoCorrect='off'
          autoComplete='company'
        />
        <label className={this.labelClass()} htmlFor='Company'>
          Company
        </label>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/FormInput/CompanyInput.js
 **/